import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import DOMPurify from "dompurify";

const TextEditor = ({ width = "100%", height = "300px", value = "", setValue }) => {
    const modules = {
        toolbar: [
            [{ font: [] }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ script: "sub" }, { script: "super" }],
            [{ list: "ordered" }, { list: "bullet" }],
            ["blockquote", "code-block"],
            [{ align: [] }],
            [{ color: [] }, { background: [] }],
            ["link", "image", "video"],
            ["clean"],
        ],
    };

    const formats = [
        "font", "size", "header", "bold", "italic", "underline", "strike",
        "script", "list", "bullet", "blockquote", "code-block",
        "align", "color", "background", "link", "image", "video"
    ];

    const handleChange = (content, delta, source) => {
        if (source === "user") {
            setValue(content);
        }
    };

    return (
        <div style={{ width, height }}>
            <ReactQuill
                theme="snow"
                value={value || ""}
                onChange={handleChange}
                modules={modules}
                formats={formats}
                style={{ height: `calc(${height} - 2rem)` }}
            />
        </div>
    );
};

const TextEditor2 = ({ width = "100%", height = "200px", value = "", setValue }) => {
    const modules = {
        toolbar: [
            ["bold", "italic"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["clean"],
        ],
    };

    const formats = ["bold", "italic", "list", "ordered", "bullet"];

    const handleChange = (content, delta, source) => {
        if (source === "user") {
            setValue(content);
        }
    };

    return (
        <div style={{ width, height }}>
            <ReactQuill
                theme="snow"
                value={value}
                onChange={handleChange}
                modules={modules}
                formats={formats}
                style={{ height: `calc(${height} - 2rem)` }}
            />
        </div>
    );
};

const DisplayContent = ({ content }) => {
    const safeContent = DOMPurify.sanitize(content, {
        ADD_TAGS: ["iframe"],
        ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling"],
    });

    return <div dangerouslySetInnerHTML={{ __html: safeContent }} />;
};

export { TextEditor, DisplayContent, TextEditor2 };
